export const contactConstants = {
    GET_LIST_REQUEST: 'CONTACTS_GET_REQUEST',
    GET_LIST_SUCCESS: 'CONTACTS_GET_SUCCESS',
    GET_LIST_FAILURE: 'CONTACTS_GET_FAILURE',

    ADD_REQUEST: 'CONTACTS_ADD_REQUEST',
    ADD_SUCCESS: 'CONTACTS_ADD_SUCCESS',
    ADD_FAILURE: 'CONTACTS_ADD_FAILURE',

    EDIT_REQUEST: 'CONTACTS_EDIT_REQUEST',
    EDIT_SUCCESS: 'CONTACTS_EDIT_SUCCESS',
    EDIT_FAILURE: 'CONTACTS_EDIT_FAILURE',

    DELETE_REQUEST: 'CONTACTS_DELETE_REQUEST',
    DELETE_SUCCESS: 'CONTACTS_DELETE_SUCCESS',
    DELETE_FAILURE: 'CONTACTS_DELETE_FAILURE',
}